const carouselItems = [
  {
    id: 1,
    title: '2026暑期档：热门综艺大盘点，哪档节目最值得追？',
    desc: '从选秀到真人秀，从脱口秀到音乐竞技，今年暑期档综艺百花齐放，我们整理了最受关注的十档节目。',
    label: '暑期特辑',
    imageUrl: 'https://readdy.ai/api/search-image?query=Summer%20variety%20show%20themed%20abstract%20illustration%20with%20stage%20lights%20and%20microphone%20elements%2C%20warm%20coral%20and%20gold%20gradients%2C%20modern%20flat%20design%20with%20playful%20geometric%20shapes%2C%20clean%20composition%2C%20entertainment%20media%20banner&width=600&height=350&seq=carousel-01&orientation=landscape',
    heat: '热度 9.8',
  },
  {
    id: 2,
    title: '娱乐圈上半年大事记：哪些瓜让你印象最深？',
    desc: '从恋情曝光到综艺名场面，从影视作品到音乐榜单，回顾2026上半年那些让人津津乐道的娱乐圈热点事件。',
    label: '半年盘点',
    imageUrl: 'https://readdy.ai/api/search-image?query=Entertainment%20year%20review%20abstract%20collage%20style%20illustration%20with%20newspaper%20and%20camera%20motifs%2C%20warm%20amber%20and%20rose%20tones%2C%20editorial%20design%20aesthetic%2C%20geometric%20layout%2C%20clean%20minimal%20background&width=600&height=350&seq=carousel-02&orientation=landscape',
    heat: '热度 9.6',
  },
  {
    id: 3,
    title: '新生代偶像崛起：2026年最值得关注的十位新人',
    desc: '选秀节目和短视频平台不断涌现新面孔，我们为你盘点今年崭露头角的新生代偶像及他们的代表作品。',
    label: '新人速递',
    imageUrl: 'https://readdy.ai/api/search-image?query=Rising%20stars%20and%20new%20talents%20abstract%20illustration%20with%20spotlight%20and%20sparkle%20elements%2C%20warm%20orange%20and%20soft%20pink%20palette%2C%20modern%20minimal%20design%2C%20fashion%20editorial%20style%2C%20clean%20geometric%20composition&width=600&height=350&seq=carousel-03&orientation=landscape',
    heat: '热度 9.3',
  },
  {
    id: 4,
    title: '热门影视剧热议榜：弹幕量最高的五部作品',
    desc: '一部好剧的标准之一就是弹幕有多热闹！我们统计了近期弹幕互动量最高的五部影视剧，看看有没有你追的那部。',
    label: '弹幕排行',
    imageUrl: 'https://readdy.ai/api/search-image?query=Film%20and%20drama%20discussion%20abstract%20illustration%20with%20chat%20bubbles%20and%20popcorn%20elements%2C%20warm%20coral%20and%20deep%20rose%20color%20scheme%2C%20modern%20flat%20design%2C%20social%20media%20commentary%20aesthetic%2C%20clean%20minimal%20layout&width=600&height=350&seq=carousel-04&orientation=landscape',
    heat: '热度 9.1',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[500px] mx-auto">
            深度解读近期最受关注的娱乐热点事件
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <article key={item.id} className="group rounded-lg overflow-hidden bg-background-100 border border-background-200/60 transition-all duration-300 hover:border-primary-200 cursor-pointer">
              <div className="overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full aspect-[16/9] object-cover transition-transform duration-500 group-hover:scale-105"
                  width="600"
                  height="350"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-2 mb-3 flex-wrap">
                  <span className="inline-block text-xs font-bold text-accent-500 bg-accent-50 px-2.5 py-1 rounded">
                    {item.label}
                  </span>
                  <span className="text-xs text-foreground-400">
                    <i className="ri-fire-line mr-1 text-primary-500"></i>
                    {item.heat}
                  </span>
                </div>
                <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}